import React from "react";
import { formatNumber2 } from "../../../utils/currencyFormat";
import { tinhTangTruong, dinhDangSo } from "./periodUtils";

const MAU_TANG = "#00B69B";
const MAU_GIAM = "#FF5170";

export const SummarySectionLoiNhuan = ({
  data,
  loading,
  onItemClick,
  config,
  isMoney88,
  loiNhuanKyTruoc,
  kyTruoc,
}) => {
  const item = data && data.length > 0 ? data[0] : {};
  const { tyLe } = tinhTangTruong(item.LoiNhuanRong, loiNhuanKyTruoc);
  const laTang = tyLe !== null && tyLe > 0;
  const laGiam = tyLe !== null && tyLe < 0;
  const tieuDeTangTruong = `Tăng trưởng so với ${
    (kyTruoc && kyTruoc.nhan) || "kỳ trước"
  }${kyTruoc && kyTruoc.khoangNgay ? ` (${kyTruoc.khoangNgay})` : ""}: ${formatNumber2(
    loiNhuanKyTruoc
  )}`;
  const showBanHang =
    config?.isBanHangTraGop === "1" || config?.IsBanHangTraGop === "1";
  const showTrichLap =
    config?.isTrichLapDuPhong === "1" || config?.IsTrichLapDuPhong === "1";
  let countThu = 4;
  if (showBanHang) countThu++;
  if (showTrichLap) countThu++;
  let countChi = 2;
  if (showTrichLap) countChi++;
  const flexThu = countThu;
  const flexChi = countChi;
  const flexLai = 1.5;
  const H_MAIN_HEADER = 50;
  const H_SUB_HEADER = 40;
  const H_VALUE = 50;
  const H_TOTAL = 60;
  const H_LAI_HEADER = H_MAIN_HEADER + H_SUB_HEADER;
  const H_LAI_VALUE = H_VALUE + H_TOTAL;
  const scrollWrapperStyle = {
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
    width: "100%",
    border: "1px solid #d1d3e2",
    borderRadius: "12px",
    backgroundColor: "#fff",
    boxShadow: "0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15)",
  };
  const containerStyle = {
    display: "flex",
    fontFamily: "Nunito, sans-serif",
    minWidth: "fit-content",
    width: "100%",
  };
  const headerStyle = {
    height: `${H_MAIN_HEADER}px`,
    backgroundColor: "#f1f3f6",
    color: "#2B335E",
    fontWeight: "bold",
    borderBottom: "1px solid #e3e6f0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
  };
  const cellHeaderStyle = {
    height: `${H_SUB_HEADER}px`,
    fontWeight: "bold",
    color: "#2B335E",
    fontSize: "13px",
    borderBottom: "1px solid #eee",
    backgroundColor: "#fafbfc",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
    padding: "0 10px",
  };
  const valueStyle = {
    height: `${H_VALUE}px`,
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
    padding: "0 10px",
    color: "#00B69B",
  };
  const totalLabelStyle = {
    height: `${H_TOTAL}px`,
    fontSize: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderTop: "1px solid #e3e6f0",
    whiteSpace: "nowrap",
    padding: "0 10px",
  };
  const laiHeaderStyle = {
    height: `${H_LAI_HEADER}px`,
    backgroundColor: "#f1f3f6",
    color: "#2B335E",
    fontWeight: "bold",
    textTransform: "uppercase",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderBottom: "1px solid #e3e6f0",
    whiteSpace: "nowrap",
  };
  const laiValueStyle = {
    height: `${H_LAI_VALUE}px`,
    display: "flex",
    // Nhà không bật isMoney88 không có dòng tăng trưởng nên giữ nguyên layout cũ
    flexDirection: isMoney88 ? "column" : "row",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    whiteSpace: "nowrap",
    padding: "0 10px",
  };
  const tangTruongStyle = {
    fontSize: "13px",
    fontWeight: 700,
    marginTop: "4px",
    color: laTang ? MAU_TANG : laGiam ? MAU_GIAM : "#2B335E",
  };
  const borderRight = { borderRight: "1px solid #e3e6f0" };

  const renderCell = (title, value, type, isLast = false) => (
    <div
      style={{ flex: 1, ...(!isLast ? borderRight : {}) }}
      className="d-flex flex-column text-center"
    >
      <div style={cellHeaderStyle}>{title}</div>
      <div
        style={valueStyle}
        onClick={() =>
          onItemClick &&
          onItemClick(
            type,
            type === "thungoai" ? "Thu ngoài lề" : `Chi tiết ${title}`
          )
        }
      >
        <span className="color-xanh-bold btn-link">
          {" "}
          {loading ? (
            <div className="spinner-border spinner-border-sm " />
          ) : (
            formatNumber2(value)
          )}
        </span>
      </div>
    </div>
  );

  return (
    <div className="p-1">
      <div style={scrollWrapperStyle}>
        <div style={containerStyle}>
          <div
            style={{
              flex: flexThu,
              display: "flex",
              flexDirection: "column",
              ...borderRight,
            }}
          >
            <div style={headerStyle}>Tổng tiền thu</div>
            <div style={{ display: "flex" }}>
              {renderCell("Cầm đồ", item.ThuCamDo, "camdo")}
              {renderCell("Tín chấp", item.ThuTinChap, "tinchap")}
              {renderCell("Trả góp", item.ThuTraGop, "tragop")}
              {showBanHang &&
                renderCell("Bán hàng trả góp", item.ThuBHTraGop, "banhang")}
              {renderCell("Thu ngoài lề", item.ThuNgoaiLe, "thungoai")}
              {showTrichLap &&
                renderCell(
                  "Thu trích lập",
                  item.ThuTrichLap,
                  "thutrichlap",
                  true
                )}
            </div>
            <div style={totalLabelStyle} className="color-do-bold">
              {loading ? "..." : formatNumber2(item.TongThu)}
            </div>
          </div>
          <div
            style={{
              flex: flexChi,
              display: "flex",
              flexDirection: "column",
              ...borderRight,
            }}
          >
            <div style={headerStyle}>Tổng tiền chi</div>
            <div style={{ display: "flex" }}>
              {renderCell("Huy động vốn", item.ChiNhanVay, "chinhanvay")}
              {renderCell("Chi ngoài lề", item.ChiNgoaiLe, "chingoai")}
              {showTrichLap &&
                renderCell(
                  "Chi trích lập",
                  item.ChiTrichLap,
                  "chitrichlap",
                  true
                )}
            </div>
            <div style={totalLabelStyle} className="color-do-bold">
              {loading ? "..." : formatNumber2(item.TongChi)}
            </div>
          </div>
          <div
            style={{ flex: flexLai, display: "flex", flexDirection: "column" }}
          >
            <div style={laiHeaderStyle} >Thống kê lãi</div>
            <div style={laiValueStyle} className="color-do-bold">
              {loading ? (
                <div className="spinner-border text-danger" />
              ) : (
                <>
                  <div>{formatNumber2(item.LoiNhuanRong)}</div>
                  {isMoney88 && (
                    <div style={tangTruongStyle} title={tieuDeTangTruong}>
                      {tyLe === null
                        ? "—"
                        : `${laTang ? "▲" : laGiam ? "▼" : ""} ${dinhDangSo(
                            Math.abs(tyLe)
                          )}%`.trim()}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
